<template>
  <Transition name="fade">
    <div :class="{ 'p-8': loading }" class="combo-select">
      <DrLoader v-if="loading" />
      <div v-else-if="!loading && filteredCompanies.length">
        <div class="combo-heading">Select your business below</div>
        <div class="combo-list">
          <div
            v-for="(company, index) in filteredCompanies"
            :key="company.company_number"
            :data-cy="`btn-select-company-${index}`"
            class="combo-item"
            tabindex="0"
            @mousedown="selectCompany(company)"
            @keydown.enter.prevent="selectCompany(company)"
          >
            <div class="combo-name">{{ company.title }}</div>
            <div class="combo-meta">
              {{ company.company_number }} |
              {{ company.address.premises.replace(/\ $/, '') }}
              {{ company.address.address_line_1 }}
            </div>
            <DrIcon svg="angle-right" width="25" height="25" class="combo-icon" />
          </div>
        </div>
      </div>
      <div v-else>
        <div class="combo-error">No matches found.</div>
      </div>
    </div>
  </Transition>
</template>

<script>
import axiosCompaniesHouseApi from '@/services/axiosCompaniesHouseApi'

export default {
  props: {
    businessName: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      companies: [],
      loading: false,
      debounceTimeout: null,
    }
  },
  computed: {
    /**
     * @Note: Check to see if company has postal_code, to be removed when we got international.
     * This should already be handled on the backend to allow international addresses to be
     * added.
     */
    filteredCompanies () {
      let companies = [...this.companies]
      companies = companies.filter(company => !!company.address.postal_code && company.company_status !== 'dissolved')
      return companies
    },
  },
  watch: {
    businessName: {
      handler () {
        this.searchCompanies()
      },
      immediate: true,
    },
  },
  methods: {
    selectCompany (company) {
      this.$emit('change', company)
    },
    async searchCompanies () {
      this.$store.commit('updateIsValidBusiness', false)
      this.$emit('hideContinue')
      clearTimeout(this.debounceTimeout)
      this.loading = true
      let query = encodeURIComponent(this.businessName)
      this.debounceTimeout = await setTimeout(() => {
        axiosCompaniesHouseApi
          .get(`search/companies?q=${query}&items_per_page=3`)
          .then((response) => {
            this.loading = false
            this.companies = response.data.items
          })
          .catch(() => {
            this.loading = false
          })
      }, 500)
    },
  },
}
</script>

<style scoped>
.combo-icon {
  @apply text-blue-500;
}

.combo-item:hover .combo-icon,
.combo-item:focus .combo-icon {
  @apply text-white;
}
</style>
